import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import api from "../../api-axios";
import showReport from "../../showReport";

const template = {
    cnpj: undefined,
    inscricoes: undefined,
    regimeTributario: 0,
    tipoEscrituracao: 3,
    optanteSimples: 0
};

export default class EspelhoCpbsNfse extends React.Component {
    constructor(props) {
        super(props);
        console.log("props declaracao", props);
        this.state = { ...template };

        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);

        const regimes = [
            { id: 0, descricao: "NÃO INFORMADO"},
            { id: 1, descricao: "NORMAL"},
            { id: 2, descricao: "AUTÔNOMO"},
            { id: 3, descricao: "SOCIEDADE DE PROFISSIONAIS"},
            { id: 4, descricao: "ESTIMATIVA"},
            { id: 5, descricao: "MEI"},
            { id: 6, descricao: "ISENTO"},
            { id: 7, descricao: "IMUNE"}
        ]

        this.regimesOptions = {
            searchEnabled: false,
            dataSource: regimes,
            valueExpr: "id",
            displayExpr: "descricao",
        };

        const tiposEscrituracao = [
            { id: 3, descricao: "TODOS"},
            { id: 0, descricao: "PRESTADOR"},
            { id: 1, descricao: "TOMADOR"},
            { id: 2, descricao: "PRESTADOR E TOMADOR"},
        ]

        this.escrituracoesOptions = {
            searchEnabled: false,
            dataSource: tiposEscrituracao,
            valueExpr: "id",
            displayExpr: "descricao",
        };
        

        this.boolOptions = {
            searchEnabled: false,
            dataSource: [
                { id: 0, descricao: "TODOS" },
                { id: 1, descricao: "SIM" },
                { id: 2, descricao: "NÃO" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <Form formData={this.state} colCount={1}>
                        <GroupItem caption="Espelho de CPBS da NFSE" >
                            <SimpleItem dataField="cnpj">
                                <Label text="CNPJ" />
                            </SimpleItem>
                            <SimpleItem dataField="inscricoes">
                                <Label text="Inscrições" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={"regimeTributario"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.regimesOptions}>
                                <Label text="Regime Tributário"/>
                            </SimpleItem>
                            <SimpleItem
                                dataField={"tipoEscrituracao"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.escrituracoesOptions}>
                                <Label text="Tipo de Escrituração"/>
                                </SimpleItem>
                            <SimpleItem
                                dataField={"optanteSimples"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.boolOptions}>
                                <Label text="Optante Simples" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={150}
                                text="Voltar"
                                icon={"back"}
                                onClick={this.cancel}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "5px" }}>
                            <Button
                                width={150}
                                text="Imprimir"
                                type="success"
                                icon={"print"}
                                onClick={this.ok}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    ok() {
        const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
        console.log(entidade);
        showReport("/report/espelho_cpbs_nfse", entidade);
    }

    cancel() {
        if (this.props.location.origem != undefined) {
            const origem = this.props.location.origem;
            this.props.history.push(origem);
        }
        else {
            this.props.history.goBack();
        }

    }
}
